export class StringUtil {
    static getNameInitials = (name) => {
        // get name initials
        const myNames = name.split(" ");
        const initials = myNames.shift().charAt(0) + myNames.pop().charAt(0);
        const nameInitials = initials.toUpperCase();
        return nameInitials
    }

    static getFirstNameLastNameInitials = (firstName, lastName) => {
        // get name initials
        const initials = firstName.charAt(0) + lastName.charAt(0);
        const nameInitials = initials.toUpperCase();
        return nameInitials
    }

    static formatStringFirstLetter(str) {
        return str?.replace(/(\B)[^ ]*/g, (match) => match?.toLowerCase())?.replace(/^[^ ]/g, (match) => match?.toUpperCase());
    }

    static capitalizeFirstLetterInStringArray(arr = []) {
        return arr.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const rest = word.slice(1).toLowerCase();

            return firstLetter + rest;
        });
    }

}